import {defineStore} from 'pinia'
import { useAuth } from '@/store/auth'
import { alertBox } from '@/composables/silverBox';
import axios from 'axios';
import { convertToEnglish, convertToPersian, numberFormat, removeCommos } from '@/composables/digits';
export const useCard = defineStore('card',{
    state : ()=>{
        return{
            code : {
                'MTN_code' : ['935','936','937','938','939','901','902','903','904','905'],
                'MCI_code' : ['910','911','912','913','914','915','916','917','918','919','990','991','992','993'],
                'RTL_code' : ['920','921','922']
            },
            mobile : '',
            amount : '',
            operator : '',
            operatorFa : '',
            type : '',
            mnp : 2,
            mode : '',
            modeFa : '',
            mobileList : '',
            shegefangiz : true,
            packageId : '',
            packageName : '',
            priod : 0,
             
        }
    },
    actions : {
        async getMobile(){
            let auth = useAuth()
            const formData = new FormData()
            formData.append('token',auth.token)
            let response = await fetch('https://radap.ir/Backend/api/section/card/mobile.php',{
                method : 'POST',
                body : formData
            })
            let data = await response.json()
            if(data.login == 'true'){
                this.mobile  = data.mobile
            }
        },
        reset(){
            this.getMobile()
            this.amount = ''
            this.operator = ''
            this.operatorFa = ''
            this.type = ''
            this.mnp = 2,
            this.mode = ''
            this.modeFa = ''
            this.mobileList = ''
            this.shegefangiz = true,
            this.packageId = ''
            this.packageName = ''
            this.priod = 0
        },
        getMobileList(){
            let auth = useAuth()
            let mobile = convertToEnglish(this.mobile)
            if(!mobile){
                mobile = '09'
            }
            const formData = new FormData()
            formData.append('text',mobile)
            formData.append('token',auth.token)
            axios.post('https://radap.ir/Backend/api/section/card/mobiles.php',formData)
                .then(response =>{
                    if(response.data){
                        if(response.data.length > 0){
                            this.mobileList = response.data;
                        }else{
                            this.mobileList = '';
                        }
                    }else{
                        this.mobileList = '';
                    }
                })
        },
        setOperator(e){
            if(document.getElementsByClassName('type-item')[0].classList.contains('active')){
                document.querySelector('.active').classList.remove('active')
            }else if(document.getElementsByClassName('type-item')[1].classList.contains('active')){
                document.querySelector('.active').classList.remove('active')
            }else if(document.getElementsByClassName('type-item')[2].classList.contains('active')){
                document.querySelector('.active').classList.remove('active')
            }
              e.target.parentElement.classList.add('active')
              if(document.querySelector('.active').classList.contains('hamrahaval')){
                  this.shegefangiz = false
              }else{
                  this.shegefangiz = true
              }
        },
        setTypeIrancell(e){
            document.querySelector('.checked').classList.remove('checked')
            e.target.classList.add('checked')
            this.type = e.target.getAttribute('data-number');
        },
        verifyAreaCode(){
            console.log(this.mobile);
            if(this.mobile.length == 4){
                if(document.getElementsByClassName('type-item')[0].classList.contains('active') == true){
                    document.querySelector('.active').classList.remove('active')
                  }else if(document.getElementsByClassName('type-item')[1].classList.contains('active')  == true){
                      document.querySelector('.active').classList.remove('active')
                  }else if(document.getElementsByClassName('type-item')[2].classList.contains('active')  == true){
                      document.querySelector('.active').classList.remove('active')
                  }
                if(MTN_code.indexOf(this.mobile.substring(1,4)) > -1){
                document.querySelector('.irancell-operator').classList.add('active')
            }else if(MCI_code.indexOf(this.mobile.substring(1,4)) > -1){
                document.querySelector('.hamrahaval-operator').classList.add('active')
            }else if(RTL_code.indexOf(this.mobile.substring(1,4)) > -1){
                document.querySelector('.rightel-operator').classList.add('active')
            }
           }
        },
        getPopupCardName(mobile,name){
            document.getElementById('cardNameName').value = name
            document.getElementById('cardNameMobile').value = mobile
            document.getElementById('cardNameModalBTN').click()
        },
        setTypeSim(e){
            document.querySelector('.checked').classList.remove('checked')
            e.target.classList.add('checked')
            this.type = e.target.getAttribute('data-number');
        },      
        goFactor(){
            let auth = useAuth()
            this.mnp = document.querySelector('input[name="mnp"]:checked').value;
            if(!auth.token || !auth.profile.id){
              alertBox('لطفا ابتدا وارد شوید','info',2);
              document.querySelector('#loginsModalBTN').click();
            }else{
              if(this.mobile == ''){
                  alertBox('لطفا شماره موبایل تان را وارد نمایید')
              }else if(this.amount == ''){
                  alertBox('لطفا مبلغ شارژ را وارد نمایید')
              }else if(!document.querySelector('.active')){
                  alertBox("لطفا اپراتور را انتخاب کنید")
              }else{
                  this.operator = document.querySelector('.active').getAttribute('data-operator');
                  this.operatorFa = document.querySelector('.active').getAttribute('data-operator-fa');
                if(this.mode == 'charge'){
                    if(((this.operator == 'MTN' || this.operator == 'RTL' ) && this.amount < 500) || (this.operator == 'MCI' && this.amount < 5000)){
                        if(this.operator == 'MCI'){
                            alertBox('مبالغ بالای 5000 تومان صحیح است')
                        }else{
                            alertBox('مبالغ بالای 500 تومان صحیح است')
                        }
                    }else{
                        document.getElementById('cardModalBTN').click()
                    }
                }else{
                    document.getElementById('cardModalBTN').click()
                }
            }
          }
      
        },
        setFactor(e){
            this.amount = e.target.getAttribute('data-amount');
            this.packageName = e.target.getAttribute('data-name');
            this.packageId = e.target.getAttribute('data-id');
            this.priod = e.target.getAttribute('data-priod');
            this.goFactor()
        }
    }
})